import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DocumentDetailDto } from '../../shared/models/document-details-dto';
import { ChangeRequestConstants } from '../change-request.constants';
import { ChangeRequestItem } from '../models/change-request-item';
import { RejectChangeRequestItem } from '../models/reject-change-request-item';
import { UpdateChangeRequestItem } from '../models/update-change-request-item';
import { ChangeRequestItemService } from '../services/change-request-item.service';

@Component({
  selector: 'app-reject-change-request-modal',
  templateUrl: './reject-change-request-modal.component.html',
  styleUrls: ['./reject-change-request-modal.component.scss']
})
export class RejectChangeRequestModalComponent implements OnInit {

  constructor(private changeRequestItemService: ChangeRequestItemService, private messageService: MessageService) { }
  errorMessages: string[] = [];
  @Input() isRejectChangeRequestModal!:boolean;
  @Input() selectedItems!:ChangeRequestItem[];
  @Input() documentDetails!:DocumentDetailDto;
  @Input() isLatestVersion!:boolean;
  @Output() isRejectChangeRequestModalVisible=new EventEmitter<boolean>();
  reviewerComment!: string;
  reasonForRejection!: string;
  rejectChangeRequestItem!:RejectChangeRequestItem;
  mandatoryFields = this.getDefaultMandatoryFields();
  valueField: string = 'value';
  labelField: string = 'name';
  display: boolean = true;
  rejectReasonsData: any = [];

  ngOnInit(): void {
      this.changeRequestItemService.getChangeRequestRejectReasons().subscribe(
        serviceData => {
          this.rejectReasonsData = serviceData;
        }
      );
  }


  confirmChangeRequestRejection():void{
    this.errorMessages=[];
    this.validateRejectChangeRequestModalControls();
    if(this.errorMessages.length === 0){
      this.rejectChangeRequestItem = {
        reasonForRejection: this.reasonForRejection,
        reviewerComment: this.reviewerComment
      }
      let crItems:UpdateChangeRequestItem[]=[]; 
      this.selectedItems.forEach(x=>{
        crItems.push({
          changeRequestItemNumber:this.documentDetails.number+"-v"+x.documentVersion+"-"+x.changeRequestItemNumber,
          status:ChangeRequestConstants.RejectedStatus,
          reasonForRejection:this.reasonForRejection,
          rejectionComments:this.reviewerComment,
          isLatestVersion:this.isLatestVersion,
          documentNumber:this.documentDetails.number,
          documentVersion:this.documentDetails.version,
          periodicReviewDate:null,
          description:null,
          changeRequestItemType: x.changeRequestItemType || ''
          
        })
      })

      this.changeRequestItemService.updateChangeRequestItems(crItems)
      .subscribe({
        complete:()=>{
          this.messageService.add({
            severity: ChangeRequestConstants.Severity_Info,
            summary: `${ChangeRequestConstants.ChangeRequestItemRejected_success}`
          });
          this.isRejectChangeRequestModal=false;
          this.isRejectChangeRequestModalVisible.emit(this.isRejectChangeRequestModal);
        }
      }
      )
    }
  }

  cancel():void{
    this.isRejectChangeRequestModal=false;
    this.isRejectChangeRequestModalVisible.emit(this.isRejectChangeRequestModal);
  }
  
  getDefaultMandatoryFields() {
    return {
      reasonForRejection: false,
    }
  }

  private validateRejectChangeRequestModalControls(){
    const isWhitespace = (this.reasonForRejection || '').trim().length === 0;
    if(this.reasonForRejection === "" || this.reasonForRejection === undefined || this.reasonForRejection?isWhitespace:null){
          this.mandatoryFields.reasonForRejection = true;
          this.errorMessages.push(ChangeRequestConstants.ReasonForRejectionErrorMessage); 
    }
  }
}
